import { Injectable } from '@angular/core';
import { InterventionInstanceInterface } from '../../../models/interface/intervention-instances/intervention-instance.interface';
import { InterventionInstanceProgressFeedbackInterface } from '../../../models/interface/intervention-instances/intervention-instance.progress.feedback.interface';
import { MessageThreadsInterface } from '../../../models/interface/message_threads.interface';

@Injectable({
  providedIn: 'root',
})
export class HelperFeedbackService {
  constructor() {}

  public isFeedbackRequired(answersheetId: number, instance: InterventionInstanceInterface): boolean {
    if (instance !== null) {
      return this.isFeedbackRequired2(answersheetId, instance.attributes.progress.feedback_provided);
    } else {
      return false;
    }
  }

  public isFeedbackRequired2(answersheetId: number, feedbackProvided?: InterventionInstanceProgressFeedbackInterface[]): boolean {
    if (feedbackProvided) {
      return feedbackProvided.some((value) => {
        if (Array.isArray(value.answersheet_id)) {
          return value.answersheet_id.includes(parseInt(answersheetId.toString(), 10));
        } else {
          return answersheetId.toString() === value.answersheet_id.toString();
        }
      });
    } else {
      return false;
    }
  }

  /*
  public isRead(answersheet_id: number, instance: InterventionInstanceInterface, thread_id: number) {
    if (this.isFeedbackRequired(answersheet_id, instance)) {
      const feedback_found: InterventionInstanceProgressFeedbackInterface = instance.attributes.progress.feedback_provided.find(
        (value: InterventionInstanceProgressFeedbackInterface) =>
          (value.thread_id !== null ? value.thread_id : '').toString() === thread_id.toString());
      if (feedback_found !== undefined) {
        return feedback_found.read;
      }
    } else {
      return false;
    }
  }
   */

  public isRead(answersheetId: number, instance: InterventionInstanceInterface, thread: MessageThreadsInterface): boolean {
    return this.isRead2(answersheetId, instance.attributes.progress.feedback_provided, thread);
  }

  private getFeedbackOfThread(
    feedbackProvided: InterventionInstanceProgressFeedbackInterface[],
    thread: MessageThreadsInterface,
  ): InterventionInstanceProgressFeedbackInterface | undefined {
    const wantedThreadId = thread.id.toString();
    return feedbackProvided.find((value) => {
      if (Array.isArray(value.thread_id) && Array.isArray(value.answersheet_id)) {
        return value.thread_id.some((threadId) => threadId.toString() === wantedThreadId);
      } else {
        return (value.thread_id !== null ? value.thread_id.toString() : '') === wantedThreadId;
      }
    });
  }

  public isRead2(
    answersheetId: number,
    feedbackProvided: InterventionInstanceProgressFeedbackInterface[],
    thread: MessageThreadsInterface,
  ): boolean {
    if (!thread || !this.isFeedbackRequired2(answersheetId, feedbackProvided)) {
      return false;
    }
    const feedbackFound = this.getFeedbackOfThread(feedbackProvided, thread);
    if (feedbackFound) {
      return feedbackFound.read;
    } else {
      return false;
    }
  }

  public isUnread(answersheetId: number, instance: InterventionInstanceInterface, thread: MessageThreadsInterface): boolean {
    return this.isUnread2(answersheetId, instance.attributes.progress.feedback_provided, thread);
  }

  public isUnread2(
    answersheetId: number,
    feedbackProvided: InterventionInstanceProgressFeedbackInterface[],
    thread: MessageThreadsInterface,
  ): boolean {
    if (!thread || !this.isFeedbackRequired2(answersheetId, feedbackProvided)) {
      return false;
    }
    const feedbackFound = this.getFeedbackOfThread(feedbackProvided, thread);
    if (feedbackFound) {
      return !feedbackFound.read;
    } else {
      return false;
    }
  }

  public hasUnreadFeedback(instance: InterventionInstanceInterface): boolean {
    return instance.attributes.progress.feedback_provided.some((value) => value.read === false);
  }

  public hasPendingAnswersheets(instance: InterventionInstanceInterface) {
    return instance.attributes.progress.feedback_provided.some(
      (value) => {
        if (Array.isArray(value.thread_id) && Array.isArray(value.answersheet_id)) {
          return value.answersheet_id.length > value.thread_id.length;
        } else {
          return value.thread_id === null;
        }
      }
    );
  }

  public hasFeedback(answersheetId: number, threads: MessageThreadsInterface[]): boolean {
    if (answersheetId === null || !threads) {
      return false;
    }
    return threads.some(
      (thread) => thread.attributes.answersheet_id.toString() === answersheetId.toString(),
    );
  }

  public isAllRead(instance: InterventionInstanceInterface): boolean {
    return instance.attributes.progress.feedback_provided.every((progressFeedback) => progressFeedback.read);
  }

  public hasCreatedFeedback(alreadyCreatedThreads: MessageThreadsInterface[], answersheetId?: number): boolean {
    if (answersheetId) {
      return alreadyCreatedThreads.some(
        (thread) => thread.attributes.answersheet_id.toString() === answersheetId.toString(),
      );
    } else {
      return alreadyCreatedThreads.length > 0;
    }
  }

  public hasSubmittedFeedback(answersheetId: number, instance: InterventionInstanceInterface) {
    if (!!instance) {
      const found = instance.attributes.progress.feedback_provided.find(
        (value) => {
          if (Array.isArray(value.answersheet_id)) {
            return value.answersheet_id.includes(parseInt(answersheetId.toString(), 10));
          } else {
            return answersheetId.toString() === value.answersheet_id.toString();
          }
        }
      );
      return found ? found.thread_id !== null : false;
    } else {
      return false;
    }
  }
}
